exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cancelling{max-width:536px}.cancelling .ml-2{margin-left:0!important}.cancelling .radio-buttons{padding-top:4px}.cancelling textarea{width:100%;margin-bottom:6px}.account .main-form__field{color:#636b6f}.account .header-home{font-size:22px;font-weight:400;color:#495057}", ""]);

// exports
